import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FinalMessage from "./FinalMessage";

export default function Layout() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-[#fbf8f5]">
            <Navbar />
            <main className="flex-1 pt-20">
                <Outlet />
            </main>
            <FinalMessage />
            <Footer />
        </div>
    );
}
